define('core/models/mixins',[
    'underscore',
    'moment',

    'core/time',
], function (
    _,
    moment,

    time
) {
    'use strict';

    function withCreatedAt() {
        // Changes moment's relative time format
        // We want the future text to be custom
        moment.locale('en', {
            relativeTime: {
                future: '%s from now',
                past: '%s ago',
                s: 'a few seconds',
                ss: '%d seconds',
                m: 'a minute',
                mm: '%d minutes',
                h: 'an hour',
                hh: '%d hours',
                d: 'a day',
                dd: '%d days',
                M: 'a month',
                MM: '%d months',
                y: 'a year',
                yy: '%d years',
            },
        });

        /**
         * Gets the moment for a post attribute. Defaults to getting createdAt if no attribute is given.
         *
         * @param {string} [attr] - the post attribute to get the moment of
         * @returns {Object} - the moment for the post attribute
         */
        this._getCreatedMoment = _.memoize(function _getCreatedMoment(attr) {
            var datetime = this.get(attr || 'createdAt');

            if (!datetime)
                return;

            return moment(time.assureTzOffset(datetime),
                time.ISO_8601);
        }, function (attr) { return this.get(attr || 'createdAt'); });

        /**
         * Gets the relative time for a post attribute. Defaults to getting createdAt if no attribute is given.
         * Can't memoize this since it relies on the changing value of "now"
         *
         * @param {string} [attr] - the post attribute to get the relative time of
         * @returns {Object} - the moment for the post attribute's relative time
         */
        this.getRelativeCreatedAt = function (attr) {
            var datetime = this._getCreatedMoment(attr);
            // Using .from(+new Date()) instead of .fromNow since it is about
            // 2x faster. `moment()` is kind of expensive.
            return datetime && datetime.from(Number(new Date()));
        };

        /**
         * Gets the formatted time for a post attribute. Defaults to getting createdAt if no attribute is given.
         *
         * @param {string} [attr] - the post attribute to get the formatted time of
         * @returns {Object} - the moment for the post attribute's formatted time
         */
        this.getFormattedCreatedAt = _.memoize(function getFormattedCreatedAt(attr) {
            var datetime = this._getCreatedMoment(attr);
            return datetime && datetime.format('LLLL');
        }, function (attr) { return this.get(attr || 'createdAt'); });
    }

    return {
        withCreatedAt: withCreatedAt,
    };
});

